import * as React from 'react';

interface MyAvailabiltyBackwardProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const MyAvailabiltyBackward: React.FC<MyAvailabiltyBackwardProps> = ({
  color = '#292A34',
  ...props
}) => (
  <svg
    width={10}
    height={17}
    viewBox="0 0 10 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.89844 15.5062L1.69925 8.30704L8.89844 1.10785"
      stroke={color}
      strokeWidth={2.05691}
    />
  </svg>
);

export default MyAvailabiltyBackward;
